import { cn } from "@/lib/utils";
import { useMeasurementFormatter } from "@/v2/hooks/useMeasurementFormatter";
import type { HintSourceUnit } from "@/v2/utils/measurement";

interface ConvertedValueHintProps {
  value: number | string | null | undefined;
  from: HintSourceUnit;
  className?: string;
}

function toNumber(value: number | string | null | undefined): number | null {
  if (value == null) {
    return null;
  }
  if (typeof value === "number") {
    return value;
  }
  return value.trim() === "" ? null : Number(value);
}

/**
 * Read-only conversion shown beside an SI input, so an operator on imperial units can sanity
 * check a value they still have to type in metres or kilometres. Renders nothing for metric
 * organizations, and nothing while the field is empty or not a number.
 */
export function ConvertedValueHint({
  value,
  from,
  className,
}: ConvertedValueHintProps) {
  const { hint } = useMeasurementFormatter();
  const text = hint(toNumber(value), from);

  if (text == null) {
    return null;
  }

  return (
    <span
      className={cn(
        "tw-text-xs tw-text-muted-foreground tw-whitespace-nowrap",
        className
      )}
    >
      {text}
    </span>
  );
}
